<div class="cx-banner-grid">
  <div class="cx-banner-grid__row">
    @for (banner of banners(); track banner.uid) {
      <div class="cx-banner-grid__row--{{ banner.columnSize }}">
        @if (banner.link) {
          <cx-link [link]="banner.link">
            <cx-media [media]="banner.medias" />
          </cx-link>
        } @else {
          <cx-media [media]="banner.medias" />
        }
      </div>
    }
  </div>
</div>
